import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const WS_URL = `${API.replace(/^http/, "ws")}/ws`;

export const api = axios.create({ baseURL: API });

function deviceId() {
  const key = "pokedrop_device";
  const fromCookie = (document.cookie.match(/(?:^|; )pokedrop_device=([^;]+)/) || [])[1];
  let id = localStorage.getItem(key) || fromCookie;
  if (!id) id = (crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2)}-${Math.random().toString(36).slice(2)}`);
  localStorage.setItem(key, id);
  if (fromCookie !== id) document.cookie = `pokedrop_device=${id}; max-age=315360000; path=/; SameSite=Lax`;
  return id;
}

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("pokedrop_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  config.headers["X-Device-Id"] = deviceId();
  return config;
});

export function fileUrl(path) {
  if (!path) return null;
  if (path.startsWith("http")) return path;
  return `${API}/files/${path}`;
}

export function trackingUrl(num) {
  if (!num) return null;
  const t = String(num).trim();
  const u = t.toUpperCase();
  if (/^1Z[0-9A-Z]{16}$/.test(u)) return `https://www.ups.com/track?loc=en_US&tracknum=${encodeURIComponent(t)}`;
  if (/^(94|93|92|95|82|420)\d{18,24}$/.test(t) || /^[A-Z]{2}\d{9}US$/.test(u)) return `https://tools.usps.com/go/TrackConfirmAction?tLabels=${encodeURIComponent(t)}`;
  if (/^\d{12}$|^\d{15}$|^\d{20,22}$/.test(t)) return `https://www.fedex.com/fedextrack/?trknbr=${encodeURIComponent(t)}`;
  return `https://www.google.com/search?q=${encodeURIComponent("track package " + t)}`;
}

export function carrierName(num) {
  if (!num) return "";
  const t = String(num).trim();
  const u = t.toUpperCase();
  if (/^1Z[0-9A-Z]{16}$/.test(u)) return "UPS";
  if (/^(94|93|92|95|82|420)\d{18,24}$/.test(t) || /^[A-Z]{2}\d{9}US$/.test(u)) return "USPS";
  if (/^\d{12}$|^\d{15}$|^\d{20,22}$/.test(t)) return "FedEx";
  return "Track";
}

// Official cert-verification links per grading company. PSA/CGC/TAG support a
// direct per-cert URL; Beckett/Degree/AGS open their official lookup page.
export function certUrl(brand, cert) {
  const c = encodeURIComponent((cert || "").trim());
  if (!c) return null;
  switch ((brand || "").toLowerCase()) {
    case "psa": return `https://www.psacard.com/cert/${c}`;
    case "cgc": return `https://www.cgccards.com/certlookup/${c}`;
    case "tag": return `https://tagd.co/${c}`;
    case "beckett": return `https://www.beckett.com/grading/card-lookup`;
    case "degree": return `https://degreegrading.com/certification-lookup/`;
    case "ags": return `https://agscard.com/learn/how-to-verify-your-ags-grades`;
    default: return null;
  }
}

export function apiError(e) {
  const detail = e?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => d?.msg || JSON.stringify(d)).join(" ");
  if (detail?.msg) return detail.msg;
  return e?.message || "Something went wrong";
}
